<div class="row justify-content-center">
  <div class="col-10">
    <div class="row justify-content-start">
      @if ((isFarmMapApp || isGlobalApp) &&
        (PermissionsType.VIEW_INVENTORY | hasPermission:entitySelected.label)) {
        <div
          class="bottom-margin"
          [class.px-0]="isOguDeploymentEnable"
          >
          <p class="global-list-text">This App will be available for all organizations</p>
          <div [ngbTooltip]="{
           condition: isGlobalApp && !(PermissionsType.DEPLOY_GLOBAL_APP | hasPermission),
           output: 'This action is not allowed. Please contact your administrator.',
           alternative: {
            condition: isFarmMapApp,
            output: 'App is already deployed at product level'
           }} | showCase"
            class="form-check d-inline-block form-switch">
            <input (change)="askForConfirmation($event)"
              [(ngModel)]="isDeployedToSeco"
              [disabled]="!(PermissionsType.DEPLOY_GLOBAL_APP | hasPermission) || isFarmMapApp"
              class="form-check-input"
              id="deployed-to-seco-product-check"
              type="checkbox"
              value="">
              <label class="form-check-label" for="deployed-to-seco-product-check"
                id="deployed-to-seco-product-label">
                Deploy to all organizations
              </label>
            </div>
          </div>
        }
      </div>
    </div>
  </div>

  <div class="row px-0 m-0 align-items-center justify-content-center">
    @if (isOfficeApp && !isDeployedToSeco() || isFarmMapApp) {
      <div
        class="col-10 px-0">
        @if (PermissionsType.VIEW_INVENTORY | hasPermission:entitySelected.label) {
          @if (app | userLevelDeploymentAvailable) {
            <form class="font-radio-button mb-2">
              <div class="mr-6 d-flex flex-row" role="radiogroup">
                @for (deploymentLevel of (deploymentService.availableDeploymentLevels$ | async);
                  track deploymentLevel) {
                  <div class="form-check px-6 py-2"
                   [ngbTooltip]="deploymentLevel.level === DEPLOYMENT_TARGETS.USER &&
                   isFarmMapApp ? 'User deployment not available for this app' : ''">
                    <input
                      (change)="changeDeploymentLevel($event, deploymentLevel.level!)"
                      [checked]="deploymentLevel?.checked"
                      [id]="'category-radio-button-' + deploymentLevel.level"
                      class="form-check-input"
                  [disabled]="
                    (deploymentLevel.level === DEPLOYMENT_TARGETS.USER && isOguDeploymentEnable && anyOrgLevelAccess) ||
(deploymentLevel.level === DEPLOYMENT_TARGETS.USER && isFarmMapApp)"
                      type="radio"/>
                      <label [for]="'category-radio-button-' + deploymentLevel.level"
                        class="form-check-label">
                        {{deploymentLevel.label }}
                      </label>
                    </div>
                  }
                </div>
              </form>
            } @else {
              <p class="fw-normal not-available" id="only-user-level-deployment-label">
                <span aria-hidden="true" class="fa-info-circle pr-1"></span>
                This app can only be deployed at office level
              </p>
            }
            <div class="input-group px-0">
              @if (deploymentCategory.level === DEPLOYMENT_TARGETS.USER) {
                <ng-container
                  id="users-search-input">
                  <div class="w-15">
                    <ng-select (change)="searchUsersOnSelectedOffice()" [(ngModel)]="selectedOffice"
                      [items]="officeIds!" [multiple]="false" [virtualScroll]="true"
                      class="h-100 w-100"
                      id="office-selector"
                      placeholder="Select an office"
                      [inputAttrs]="{ 'aria-label': 'select user\'s office', 'autocomplete': 'on'}"
                      >
                      <ng-template let-item="item" let-search="searchTerm" ng-option-tmp>
                        <div class="office-list-element">
                          <label (click)="$event.preventDefault();" [dfOptionHighlight]="search"
                          class="office-list-element">{{item}}</label>
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                </ng-container>
              }
              @if (!isOguDeploymentEnable ||
                (isOguDeploymentEnable && deploymentCategory.level === DEPLOYMENT_TARGETS.USER)) {
                <textarea
                  (input)="applyFilterLists($event.currentTarget.value)"
                  [formControl]="userOfficeFilter"
                  [id]="'filter-input'"
                  [placeholder]="deploymentCategory.searchPlaceholder"
                  class="form-control starting-textarea mb-2"
                  name="filter-input"
                  rows="1"
                  spellcheck="false"
                  type="text"
                ></textarea>
              }
            </div>
            @if (deploymentCategory.level === DEPLOYMENT_TARGETS.USER) {
              <caption
                class="input-group pt-0">
                Select an office first to search for users that do not have the app deployed.
              </caption>
            }
          } @else {
            <textarea
              (input)="applyFilterLists($event.currentTarget.value)"
              [formControl]="userOfficeFilter"
              [id]="'filter-input'"
              [placeholder]="deploymentCategory.searchPlaceholder"
              class="form-control starting-textarea"
              name="filter-input"
              rows="1"
              spellcheck="false"
              type="text"
            ></textarea>
          }
        </div>
      }
    </div>
    @if (!isOguDeploymentEnable) {
      <div class="mt-5">
        <div class="row m-0 px-0 align-items-center justify-content-center">
          <div class="col-10">
            @if (isOfficeApp) {
              <div [hidden]="isDeployedToSeco()"
                class="row px-0 align-items-center justify-content-between">
                <div class="col-5 ps-0 pe-0" id="manage-offices">
                  <ama-ng-app-store-deployment-list
                    [app]="app"
                    [deploymentLevel]="deploymentCategory"
                                [itemsList]="{
              output :
               (deploymentService.undeployments$) | async,
               condition: PermissionsType.MANAGE_MARKET_CATALOG | hasPermission:entitySelected.label
               } | showCase:[]"
                    [section]="DEPLOYMENT_SECTION.UNDEPLOY"
                    class="flex-fill"
                    label="App not deployed"
                    >
                  </ama-ng-app-store-deployment-list>
                </div>
                <div class="arrows col-lg-12 col-2 pe-5 align-items-center">
                  <button (click)="moveEntitiesToDeploy()"
                                [disabled]="!((deploymentService.isAnyEntitySelectedToBeDeployed$ | async) &&
                 (PermissionsType.MANAGE_MARKET_CATALOG | hasPermission:entitySelected.label))"
                    class="btn btn-outline-primary px-8 w-100"
                    type="button"
                    >Add<span class="fa-chevron-right fa-solid px-2"></span>
                  </button>
                  <br/>
                  <button (click)="toUndeployEntities()"
                                [disabled]="!((deploymentService.isAnyEntitySelectedToBeUndeployed$ | async) &&
                (PermissionsType.MANAGE_MARKET_CATALOG | hasPermission:entitySelected.label))"
                    class="btn btn-outline-primary px-8 w-100"
                    type="button"
                    >
                    <span
                      class="fa-chevron-left fa-solid px-2"
                    ></span>
                    Remove
                  </button>
                </div>
                <div class="col-5 ps-0 pe-0" id="targeted-offices">
                  <ama-ng-app-store-deployment-list
                    (editConfigurationEvent)="openConfigurationDialog($event)"
                    [app]="app"
                    [deploymentLevel]="deploymentCategory"
                    [editConfiguration]="true"
                    [entitySelected]="entitySelected!"
                    [isConfigurationAvailable]="selectedConfigurationsObject.length > 0"
                    [itemsList]="(deploymentService.deployments$ | async)!"
                    [section]="DEPLOYMENT_SECTION.DEPLOY"
                    label="App deployed"
                  ></ama-ng-app-store-deployment-list>
                </div>
              </div>
            }
          </div>
          <div class="col-10 px-0 d-flex justify-content-end">
            @if (!isOguDeploymentEnable && infoMessage.appId === app.id && infoMessage.code !== '') {
              <ngb-alert
                [dismissible]="false"
                [type]="infoMessage.code"
                class="d-inline-flex me-4 mb-0"
                dfInsertAlertIcon
                >
                {{ infoMessage.message }}
              </ngb-alert>
            }
            <div class="d-inline-flex my-2 px-0">
              @if (isOfficeApp && !isDeployedToSeco() &&
                (deploymentService.isAnyEntitySelectedOrMoved$ | async) === true) {
                <button
                  (click)="cancel()"
                  class="btn btn-outline-primary mb-2 mb-md-0 me-2"
                  id="cancel-btn"
                  type="button"
                  >
                  Cancel
                </button>
              }
              @if (isOfficeApp && !isDeployedToSeco()) {
                <button
                  (click)="pushApp()"
                            [disabled]="!((PermissionsType.MANAGE_MARKET_CATALOG | hasPermission:entitySelected.label)
                            && isAnyDeploymentChange)"
                  class="btn btn-primary mb-2 mb-md-0"
                  id="deploy-btn"
                  name="action"
                  type="submit"
                  >
                  Apply
                </button>
              }
            </div>
          </div>
        </div>
      </div>
    } @else {
      @if (deploymentCategory.level === DEPLOYMENT_TARGETS.USER) {
        <div class="mt-5">
          <div class="row m-0 px-0 align-items-center justify-content-center">
            <div class="col-10">
              @if (isOfficeApp) {
                <div [hidden]="isDeployedToSeco()"
                  class="row px-0 align-items-center justify-content-between">
                  <div class="col-5 ps-0 pe-0" id="manage-offices">
                    <ama-ng-app-store-deployment-list
                      [app]="app"
                      [deploymentLevel]="deploymentCategory"
                                [itemsList]="{
              output :
               (deploymentService.undeployments$) | async,
               condition: PermissionsType.MANAGE_MARKET_CATALOG | hasPermission:entitySelected.label
               } | showCase:[]"
                      [section]="DEPLOYMENT_SECTION.UNDEPLOY"
                      class="flex-fill"
                      label="App not deployed"
                      >
                    </ama-ng-app-store-deployment-list>
                  </div>
                  <div class="arrows col-lg-12 col-2 pe-5 align-items-center">
                    <button (click)="moveEntitiesToDeploy()"
                                [disabled]="!((deploymentService.isAnyEntitySelectedToBeDeployed$ | async) &&
                 (PermissionsType.MANAGE_MARKET_CATALOG | hasPermission:entitySelected.label))"
                      class="btn btn-outline-primary px-8 w-100"
                      type="button"
                      >Add<span class="fa-chevron-right fa-solid px-2"></span>
                    </button>
                    <br/>
                    <button (click)="toUndeployEntities()"
                                [disabled]="!((deploymentService.isAnyEntitySelectedToBeUndeployed$ | async) &&
                (PermissionsType.MANAGE_MARKET_CATALOG | hasPermission:entitySelected.label))"
                      class="btn btn-outline-primary px-8 w-100"
                      type="button"
                      >
                      <span
                        class="fa-chevron-left fa-solid px-2"
                      ></span>
                      Remove
                    </button>
                  </div>
                  <div class="col-5 ps-0 pe-0" id="targeted-offices">
                    <ama-ng-app-store-deployment-list
                      (editConfigurationEvent)="openConfigurationDialog($event)"
                      [app]="app"
                      [deploymentLevel]="deploymentCategory"
                      [editConfiguration]="true"
                      [entitySelected]="entitySelected!"
                      [isConfigurationAvailable]="selectedConfigurationsObject.length > 0"
                      [itemsList]="(deploymentService.deployments$ | async)!"
                      [section]="DEPLOYMENT_SECTION.DEPLOY"
                      label="App deployed"
                    ></ama-ng-app-store-deployment-list>
                  </div>
                </div>
              }
            </div>
            <div class="col-10 px-0 d-flex justify-content-end">
              @if (!isOguDeploymentEnable && infoMessage.appId === app.id && infoMessage.code !== '') {
                <ngb-alert
                  [dismissible]="false"
                  [type]="infoMessage.code"
                  class="d-inline-flex me-4 mb-0"
                  dfInsertAlertIcon
                  >
                  {{ infoMessage.message }}
                </ngb-alert>
              }
              <div class="d-inline-flex my-2 px-0">
                @if (isOfficeApp && !isDeployedToSeco() &&
                  (deploymentService.isAnyEntitySelectedOrMoved$ | async) === true) {
                  <button
                    (click)="cancel()"
                    class="btn btn-outline-primary mb-2 mb-md-0 me-2"
                    id="cancel-btn"
                    type="button"
                    >
                    Cancel
                  </button>
                }
                @if (isOfficeApp && !isDeployedToSeco()) {
                  <button
                    (click)="pushApp()"
                            [disabled]="!((PermissionsType.MANAGE_MARKET_CATALOG | hasPermission:entitySelected.label)
                            && isAnyDeploymentChange)"
                    class="btn btn-primary mb-2 mb-md-0"
                    id="deploy-btn"
                    name="action"
                    type="submit"
                    >
                    Apply
                  </button>
                }
              </div>
            </div>
          </div>
        </div>
      } @else {
        @if (isOfficeApp) {
          <div [hidden]="isDeployedToSeco() && !isFarmMapApp" class="justify-content-center row">
            <ama-ng-app-store-inventory-panels class="df-sidenav-wrapper d-flex flex-row col-10 p-0"
              [selectedActor]="deploymentService.selectedEntity$ | async"
              [selectedActorParentOrg]="deploymentService.selectedEntityParentOrg$ | async"
              [officesInSelectedEntity]="(deploymentService.officesInSelectedEntity$ | async)?.length ?? 0"
              (officeSearchChange)="deploymentService.dispatchChangeFilterValue($event)"
              (orgOguSearchChange)="deploymentService.dispatchChangeOGUsSearchingValue($event);deploymentService.scroll($event)"
              >
              <ama-ng-app-store-deployment-hierarchy-list
                [items]="(deploymentService.orgAndOguEntities$ | async) ?? []"
              ></ama-ng-app-store-deployment-hierarchy-list>
              <ama-ng-app-store-deployment-offices-list offices class="d-flex flex-column flex-grow-1">
              </ama-ng-app-store-deployment-offices-list>
              <div filterOfficeToggle class="form-check form-switch col-9">
                <div class="df-form-switch-container">
                  <input class="form-check-input"
                    name="deployedOfficeOnlyToggle"
                    type="checkbox"
                    (change)="applyDeployedOfficeFilter()"
                    id="deployed-office-only-toggle">
                    <label for="deployed-office-only-toggle" class="form-check-label pt-2">
                      {{ (deploymentService.selectOnlyDeployedOffices$ | async) ?
                      'Deployed offices only' : 'All offices' }}
                    </label>
                  </div>
                </div>
              </ama-ng-app-store-inventory-panels>
              <ama-ng-app-store-deployment-summary (pushApp)="pushApp()"></ama-ng-app-store-deployment-summary>
            </div>
          }
        }
      }
